import * as React from 'react';
import {Link, NavLink} from 'react-router-dom';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import {Trad} from '../components/';

interface INavAzioniState {
    Menu?: Dati.CRisAPIListaMenu;
    Caricamento: boolean;
    ID_MenuMain: number;
}

export class NavAzioni extends React.PureComponent<Glob.IRouteGlobaleProps, INavAzioniState> {
    public constructor(props: any) {
        super(props);
        this.state = {Menu: undefined, Caricamento: true, ID_MenuMain: -1};
    }

    public componentDidMount() {
        this.AggiornaMenu();
    }

    public componentDidUpdate() {
        this.AggiornaMenu();
    }

    private AggiornaMenu() {
        let Menu = Glob.GetMenu();
        if (Menu != undefined && Menu.ID_MenuMain != undefined && Menu.ID_MenuMain != this.state.ID_MenuMain) {
            Glob.Log(Glob.LogCat.Menu, false, "AggiornaMenu Azioni", Menu.ID_MenuMain, this.state.ID_MenuMain);
            this.setState({ID_MenuMain: Menu.ID_MenuMain});
            fetch('/api/Menu/Azioni?sessione=' + Glob.GetSessione().Sessione + "&id_MenuMain=" + Menu.ID_MenuMain)
                .then(response => {
                    if (response.ok) {
                        response.text().then(text => {
                            let data = JSON.parse(text, Glob.DateReviver) as Dati.CRisAPIListaMenu;
                            this.setState({Menu: data, Caricamento: false});
                        }).catch(e => Glob.Log(Glob.LogCat.Menu, false, "Errore caricamento NavAzioni (JSON)", e));
                    } else {
                        Glob.Log(Glob.LogCat.Menu, false, "Errore caricamento NavAzioni (HTTP)", response);
                    }
                })
                .catch(e => Glob.Log(Glob.LogCat.Menu, false, "Errore caricamento NavAzioni (Rete)", e));
        }
    }

    public render() {
        let VociMenu = this.state.Caricamento
            ? <p><em>{Trad.Trad("Caricamento...")}</em></p>
            : this.renderVociMenu();

        return VociMenu;
    }

    private popolaVariabiliDiNavigazione(url: string): string {
        var ID_Anag: number = 0;
        try {
            ID_Anag = (this.props.match.params as any).ID_Anag;
            if (ID_Anag == undefined) {
                ID_Anag = 0;
            }
        } catch (e) {
            ID_Anag = 0;
        }

        var ID_Binder: number = 0;
        try {
            ID_Binder = (this.props.match.params as any).ID_Binder;
            if (ID_Binder == undefined) {
                ID_Binder = 0;
            }
        } catch (e) {
            ID_Binder = 0;
        }

        url = url.replace("{ID_Anag}", ID_Anag.toString());
        url = url.replace("{ID_Binder}", ID_Binder.toString());

        //inserisco i segnaposti salvati nelle variabili di menu all'url
        var M = Glob.GetMenu();
        if (M != undefined) {
            if (M.VariabiliMenu != undefined) {
                for (let key in M.VariabiliMenu) {
                    let value = M.VariabiliMenu[key];
                    url = url.replace(key, value);
                }
            }
        }
        return url;
    }


    private LinkInserimento(url: string) {
        url = this.popolaVariabiliDiNavigazione(url);
        let urlSpezzato = url.split("/");
        if (urlSpezzato[urlSpezzato.length - 1].toString() == "" || Glob.IsNumeric(urlSpezzato[urlSpezzato.length - 1]))
            return <a href="#"></a>;
        else
            return <NavLink to={url + "/0"} className="kt-menu__link">
                <i className="kt-menu__link-icon fa fa-plus"><span></span>
                </i>
                <span className="kt-menu__link-text">
                    {Trad.Trad("Inserisci")}
                </span>
            </NavLink>;
    }

    private LinkVisualizzazioneAuth(funzione: Glob.Funzioni, url: string): any {
        if (Glob.AzioneAbilitata(funzione, Glob.Lettura)) {
            return <NavLink to={this.popolaVariabiliDiNavigazione(url)} className="kt-menu__link">
                <i className="kt-menu__link-icon fa fa-chevron-right">
                    <span></span>
                </i>
                <span className="kt-menu__link-text">
                    {Trad.Trad("Visualizza")}
                </span>
            </NavLink>;
        } else {
            return false;
        }
    }

    private LinkInserimentoAuth(funzione: Glob.Funzioni, url: string): any {
        if (Glob.AzioneAbilitata(funzione, Glob.Scrittura)) {
            return this.LinkInserimento(url);
        } else {
            return false;
        }
    }

    private renderVociMenu() {
        if ((this.state.Menu == undefined) || (this.state.Menu.Dati == undefined)) {
            return <span>{Trad.Trad("Errore")}</span>;
        }
        return this.state.Menu.Dati.map(dato =>
            <li className="menu kt-menu__item kt-menu__item--submenu" aria-haspopup="true"
                data-ktmenu-submenu-toggle="click" key={dato.ID_Menu}>
                <a className="kt-menu__link kt-menu__toggle">
                    <span className={'kt-menu__link-icon ' + dato.Icona}></span>
                    <span className="kt-menu__link-text"> {Trad.Trad(dato.Voce)}</span>
                    <i className="kt-menu__ver-arrow la la-angle-right"></i>
                </a>
                <div className="kt-menu__submenu bloccato">
                    <span className="kt-menu__arrow"></span>
                    <ul className="kt-menu__subnav ">
                        <li className="kt-menu__item" aria-haspopup="true">
                            {this.LinkVisualizzazioneAuth(dato.ID_Funzione, dato.Indirizzo)}
                        </li>
                        <li className="kt-menu__item" aria-haspopup="true">
                            {this.LinkInserimentoAuth(dato.ID_Funzione, dato.Indirizzo)}
                        </li>
                    </ul>
                </div>
            </li>);
    }
}



// WEBPACK FOOTER //
// ./src/layout/NavAzioni.tsx